
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","viewBox":"0 0 470 470","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"CurrentColor","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M285.812 209.57H400.28c7.024 0 12.719-5.693 12.719-12.716v-25.43c0-7.022-5.695-12.715-12.72-12.715h-53.06L460.148 45.811c4.967-4.966 4.967-13.016 0-17.982L442.164 9.851c-4.967-4.966-13.02-4.966-17.987 0L311.248 122.748V69.702c0-7.022-5.694-12.715-12.719-12.715h-25.437c-7.024 0-12.719 5.693-12.719 12.715V184.14c0 14.045 11.39 25.431 25.439 25.431z"}}),_c('path',{attrs:{"d":"M427.133 306.585c-28.046 0-55.57-4.383-81.653-13-12.793-4.334-28.493-.36-36.293 7.649l-51.471 38.853c-59.694-31.862-96.484-68.618-127.933-127.859l37.759-50.153c9.812-9.809 13.29-24.102 9.067-37.462-8.645-26.25-13.042-53.766-13.042-81.754 0-20.254-16.47-36.732-36.74-36.732H42.74C22.47 6.127 6 22.605 6 42.857c0 232.152 188.918 421.016 421.133 421.016 20.27 0 36.74-16.478 36.74-36.73v-83.829c0-20.252-16.47-36.73-36.74-36.73z"}})])])
          )
        }
      }
    